<template>
    <div>
        <Card dis-hover :bordered="false">
            <Row>
                <Col span="12">
                    <h3 v-if="!readonly">{{$t('route.fpzInvaccAdd')}}</h3>
                    <h3 v-else>{{$t('route.fpzInvaccDetail')}}</h3>
                </Col>
                <Col span="12">
                    <Steps :current="step">
                        <Step :title="$t('fpzInvaccCommon.t1')"></Step>
                        <Step :title="$t('fpzInvaccCommon.t2')"></Step>
                        <Step :title="$t('fpzInvaccCommon.t3')"></Step>
                    </Steps>
                </Col>
            </Row>
        </Card>
        <Card >
            <Form ref="formHeader" :model="invaccHeader" :label-width="90" :rules="ruleValidate">
              <Row>
                <Col span="8" push="2">
                    <FormItem :label="$t('fpzInvaccCommon.t6')" prop="organizationCode">
                        <Select v-model="invaccHeader.organizationCode" :disabled="readonly" @on-change="orgOnChange">
                            <Option v-for="item in orgList" :value="item.value" :key="item.value">{{ item.label
                            }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <!-- <Col span="8" push="4">
                    <FormItem :label="$t('fpzInvaccCommon.t7')" prop="vendorSiteCode">
                        <Select v-model="invaccHeader.vendorSiteCode" :disabled="readonly" style="width:200px">
                            <Option v-for="item in vendorSites" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Col> -->
                <Col span="8" push="4">
                    <FormItem :label="$t('fpzInvaccCommon.t8')" :required="true">
                      <Row :gutter="0">
                        <Col span="11">
                            <FormItem prop="periodFrom">
                                <Input type="text" placeholder="" :readonly="true" :disabled="readonly" v-model="invaccHeader.periodFrom">
                                    <Button slot="append" icon="ios-search" :disabled="readonly || !invaccHeader.organizationCode || (periodFlag === 'start' && dateModal.tableData.length === 1)" @click="showCustomDate('start')"></Button>
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="2" style="text-align: center">{{$t('fpzInvaccCommon.t9')}}</Col>
                        <Col span="11">
                            <FormItem prop="periodTo">
                                <Input type="text" placeholder="" :readonly="true" :disabled="readonly" v-model="invaccHeader.periodTo">
                                    <Button slot="append" icon="ios-search" :disabled="readonly || !invaccHeader.periodFrom || !invaccHeader.organizationCode" @click="showCustomDate('end')"></Button>
                                </Input>
                            </FormItem>
                        </Col>
                      </Row>
                    </FormItem>
                    </Col>
              </Row>
    
              <Row>
                <Col span="8" push="2">
                    <FormItem :label="$t('fpzInvaccCommon.t10')">
                    <Select v-model="invaccHeader.status" style="width:200px" disabled>
                        <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                    </FormItem>
                </Col>
              </Row>
    
              <Row type="flex" justify="center">
                <Col>
                    <Button v-if="!readonly" type="primary" class="mr8" @click="search" :loading="loading">
                        {{$t('fpzInvaccCommon.t11')}}
                      </Button>
                      <Button v-if="!readonly" type="ghost" class="mr8" @click="cleanData">
                        {{$t('fpzInvaccCommon.t12')}}
                      </Button>
                      <Button v-if="!readonly" type="primary" class="mr8" @click="save" :loading="loading">
                        {{$t('fpzInvaccCommon.t13')}}
                      </Button>
                      <Button type="primary" class="mr8" @click="goBack">{{$t('fpzInvaccCommon.t14')}}</Button>
                </Col>
              </Row>
            </Form>
        </Card>
        <Tabs :value="invaccDetailTabs">
            <TabPane :label="$t('fpzInvaccCommon.t16')" name="TrcItemDetail">
                <Card class="fpzInvacc-layout">
                    <p slot="title">
                        <Icon type="ios-film-outline"></Icon>
                        {{$t('fpzInvaccCommon.t23')}}
                    </p>
                    <m-assembly-table ref='pageForm'
                        :columns='transactionModule.columns'
                        :data='transactionModule.tableData'
                        :tableButtons='transactionModule.tableButtons'
                        :loading='loading'
                        :currentPage='transactionModule.settings.currentPage'
                        :pageSize='transactionModule.settings.pageSize'
                        :total='transactionModule.settings.total'
                        :settings='transactionModule.settings'
                        @onPageSizeChange='transactionOnPageSizeChange'
                        @onCurrentPageChange='transactionOnPageChange'
                    >
                    </m-assembly-table>
                  </Card> 

            </TabPane>
            <TabPane :label="$t('fpzInvaccCommon.t15')" name="invaccItemDetail" v-if="readonly">
                <Card class="fpzInvacc-layout" v-if="!hideTable">
                    <p slot="title">
                        <Icon type="ios-film-outline"></Icon>
                        {{$t('fpzInvaccCommon.t17')}}
                    </p>
                    <m-assembly-table ref='pageForm'
                        :columns='summaryModule.columns'
                        :data='summaryModule.tableData'
                        :tableButtons='summaryModule.tableButtons'
                        :loading='loading'
                        :currentPage='summaryModule.settings.currentPage'
                        :pageSize='summaryModule.settings.pageSize'
                        :total='summaryModule.settings.total'
                        :settings='summaryModule.settings'
                        @onPageSizeChange='summaryOnPageSizeChange'
                        @onCurrentPageChange='summaryOnPageChange'
                    >
                    </m-assembly-table>
                  </Card>
        
                  <!-- <Card class="fpzInvacc-layout">
                    <p slot="title">
                        <Icon type="ios-film-outline"></Icon>
                        {{$t('fpzInvaccCommon.t23')}}
                    </p>
                    <m-assembly-table ref='pageForm'
                        :columns='detailModule.columns'
                        :data='detailModule.tableData'
                        :tableButtons='detailModule.tableButtons'
                        :loading='loading'
                        :currentPage='detailModule.settings.currentPage'
                        :pageSize='detailModule.settings.pageSize'
                        :total='detailModule.settings.total'
                        :settings='detailModule.settings'
                        @onPageSizeChange='detailOnPageSizeChange'
                        @onCurrentPageChange='detailOnPageChange'
                    >
                    </m-assembly-table>
                  </Card>  -->
            </TabPane>
            
        </Tabs>

        <Modal v-model="dateModal.show"
            title=" "
                :width="800">
            <m-assembly-table ref='pageForm'
                v-if="dateModal.show"
                :columns='dateModal.columns'
                :data='dateModal.tableData'
                :loading='loading'
                :currentPage='dateModal.settings.currentPage'
                :pageSize='dateModal.settings.pageSize'
                :total='dateModal.settings.total'
                :settings='dateModal.settings'
                :height="500"
                @onRowClick="dateOnRowClick"
            >
            </m-assembly-table>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import {dateTimeChange, queryList, exportExcel} from './financialAccounting';
import axios from 'axios';
import moment from 'moment';
export default {
    components: {
        mAssemblyTable,
    },
    props: {
        readonly: {
            type: Boolean,
            default: false
        },
        hideTable: {
            type: Boolean,
            default: false
        }
    },
    data () {
        const validateDate = (rule, value, callback) => {
            if (value < this.invaccHeader.periodFrom) {
                callback(new Error(this.$t('fpzInvaccCommon.t4')));
            } else {
                callback();
            }
        };
        return {
            step: 0,
            invaccDetailTabs: '',
            itemId: '',
            headerId: '',
            periodFlag: '',
            invaccHeader: {
                orgId: '',
                organizationId: '',
                organizationCode: '',
                vendorSiteCode: '',
                periodFrom: '',
                periodTo: '',
                status: '',
            },
            ruleValidate: {
                organizationCode: [{required: true, message: this.$t('fpzInvaccCommon.t5')}],
                // vendorSiteCode: [{required: true, message: this.$t('fpzInvaccCommon.t5')}],
                periodFrom: [{required: true, message: this.$t('fpzInvaccCommon.t5'), trigger: 'blur'}],
                periodTo: [{required: true, message: this.$t('fpzInvaccCommon.t5'), trigger: 'blur'}, {validator: validateDate, trigger: 'blur'}]
            },
            orgList: [],
            vendorSites: [],
            loading: false,
            summaryModule: {
                columns: {
                    columns: [
                        // {
                        //     title: this.$t('fpzInvaccCommon.t18'), // 明细
                        //     align: 'center',
                        //     width: 80,
                        //     render: (h, params) => {
                        //         let _this = this;
                        //         return h('Button', {
                        //             props: {
                        //                 type: 'text',
                        //                 icon: 'ios-list-outline'
                        //             },
                        //             on: {
                        //                 click: () => {
                        //                     this.itemId = params.row.itemCode;
                        //                     this.detailModule.settings.currentPage = 1;
                        //                     queryLineTrcs(_this, this.headerId, this.itemId, this.headerId ? 'detail' : 'new');
                        //                 }
                        //             }
                        //         })
                        //     }
                        // },
                        {
                            title: this.$t('fpzInvaccCommon.t19'), // 物料编码
                            align: 'center',
                            key: 'itemCode',
                            minWidth: 180
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t20'), // 物料描述
                            align: 'center',
                            key: 'itemDescription',
                            tooltip: true,
                            minWidth: 300
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t21'), // 单位
                            align: 'center',
                            key: 'uom',
                            minWidth: 120
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t22'), // 接收/退货数量
                            align: 'center',
                            key: 'tranReceiveQuantity',
                            minWidth: 120
                        }
                    ]
                },
                tableData: [],
                tableButtons: {
                    customButtons: [
                        {
                            label: this.$t('fpzInvaccCommon.t32'),
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            click: (button) => {
                                exportExcel(button, this, this.invaccHeader, '/gscint/hw/invacc/exportyLinesSummary');
                            }
                        }
                    ]
                },
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            // detailModule: {
            //     columns: {
            //         columns: [
            //             {
            //                 title: this.$t('fpzInvaccCommon.t24'), // 送货单/接收单号
            //                 align: 'center',
            //                 key: 'receiptNumber',
            //                 minWidth: 150
            //             },
            //             {
            //                 title: this.$t('fpzInvaccCommon.t25'), // 送货数量
            //                 align: 'center',
            //                 key: 'deliveryQuantity',
            //                 minWidth: 110
            //             },
            //             {
            //                 title: this.$t('fpzInvaccCommon.t26'), // 接收子库
            //                 align: 'center',
            //                 key: 'subinventory',
            //                 minWidth: 110
            //             },
            //             {
            //                 title: this.$t('fpzInvaccCommon.t27'), // 事务处理日期
            //                 align: 'center',
            //                 key: 'transactionDate',
            //                 minWidth: 150,
            //                 tooltip: true
            //             },
            //             {
            //                 title: this.$t('fpzInvaccCommon.t21'), // 单位
            //                 align: 'center',
            //                 key: 'uom',
            //                 minWidth: 100
            //             },
            //             {
            //                 title: this.$t('fpzInvaccCommon.t28'), // 采购单号
            //                 align: 'center',
            //                 key: 'poNumber',
            //                 minWidth: 180
            //             },
            //             // {
            //             //     title: this.$t('fpzInvaccCommon.t29'), // 接收单号
            //             //     align: 'center',
            //             //     key: 'receiptNumber',
            //             //     minWidth: 120
            //             // },
            //             {
            //                 title: this.$t('fpzInvaccCommon.t30'), // 接收/退货数量
            //                 align: 'center',
            //                 key: 'tranReceiveQuantity',
            //                 minWidth: 150
            //             },
            //             // {
            //             //     title: this.$t('fpzInvaccCommon.t31'), // 操作者
            //             //     align: 'center',
            //             //     key: 'USER_NAME',
            //             //     minWidth: 150
            //             // }
            //         ]
            //     },
            //     tableData: [],
            //     tableButtons: {
            //         customButtons: [
            //             // {
            //             //     label: this.$t('fpzInvaccCommon.t32'),
            //             //     type: 'primary',
            //             //     icon: 'archive',
            //             //     size: 'small',
            //             //     click: (button) => {

            //             //     }
            //             // }
            //         ]
            //     },
            //     settings: {
            //         needPager: true,
            //         showElevator: true,
            //         showSizer: true,
            //         pageSizeOpts: [10, 20, 50, 100],
            //         needSearch: false,
            //         needValidation: true,
            //         currentPage: 1,
            //         pageSize: 10,
            //         total: null,
            //         submitLoading: false
            //     }
            // },
            transactionModule: {
                columns: {
                    columns: [
                        {
                            title: this.$t('fpzInvaccCommon.t19'), // 物料编码
                            align: 'center',
                            key: 'itemCode',
                            minWidth: 110
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t20'), // 物料描述
                            key: 'itemDescription',
                            tooltip: true,
                            minWidth: 200
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t24'), // 送货单号
                            align: 'center',
                            key: 'receiptNumber',
                            minWidth: 100
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t25'), // 送货数量
                            align: 'center',
                            key: 'deliveryQuantity',
                            minWidth: 80
                        },
                        // {
                        //     title: this.$t('fpzInvaccCommon.t26'), // 接收子库
                        //     align: 'center',
                        //     key: 'subinventory',
                        //     minWidth: 80
                        // },
                        {
                            title: this.$t('fpzInvaccCommon.t27'), // 事务处理日期
                            align: 'center',
                            key: 'transactionDate',
                            minWidth: 150,
                            tooltip: true,
                            render: (h, params) => {
                                let {transactionDate} = params.row;
                                return h('span', dateTimeChange(transactionDate, this.invaccHeader.organizationCode, this));
                            }
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t21'), // 单位
                            align: 'center',
                            key: 'uom',
                            minWidth: 60
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t28'), // 采购单号
                            align: 'center',
                            key: 'poNumber',
                            minWidth: 120
                        },
                        // {
                        //     title: this.$t('fpzInvaccCommon.t29'), // 接收单号
                        //     align: 'center',
                        //     key: 'receiptNumber',
                        //     minWidth: 120
                        // },
                        {
                            title: this.$t('fpzInvaccCommon.t30'), // 接收/退货数量
                            align: 'center',
                            key: 'tranReceiveQuantity',
                            minWidth: 100
                        }
                        // {
                        //     title: this.$t('fpzInvaccCommon.t31'), // 操作者
                        //     align: 'center',
                        //     key: 'USER_NAME',
                        //     minWidth: 150
                        // }
                    ]
                },
                tableData: [],
                tableButtons: {
                    customButtons: [
                        {
                            label: this.$t('fpzInvaccCommon.t32'),
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            click: (button) => {
                                this.$refs.formHeader.validate((valid) => {
                                    if (valid) {
                                        exportExcel(button, this, this.invaccHeader, this.readonly ? '/gscint/hw/invacc/exportyLines' : '/gscint/hw/invacc/exportyTransactions');
                                    }
                                });
                            }
                        }
                    ]
                },
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            statusList: [],
            dateModal: {
                show: false,
                columns: {
                    columns: [
                        {
                            title: this.$t('fpzInvaccCommon.t33'), // 序号
                            type: 'index',
                            width: 60,
                            align: 'center'
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t34'), // 月份
                            key: 'periodNumber',
                            align: 'center',
                            minWidth: 140
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t35'), // 开始日期
                            key: 'startDate',
                            align: 'center',
                            minWidth: 257
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t36'), // 截止日期
                            key: 'endDate',
                            align: 'center',
                            minWidth: 258
                        }
                    ]
                },
                tableData: [],
                settings: {
                    needPager: false,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            }
        }
    },
    methods: {
        /* 组织选择 */
        async orgOnChange (val) {
            if (val) {
                this.invaccHeader.organizationId = this.orgList.find((item) => item.value === val).erpOrgId;
                await this.getErpOuIdByOrgCode(this.invaccHeader.organizationCode);
                if (!this.readonly) {
                    this.dateSearch('start');
                }
            }
            if (!this.readonly) {
                Object.assign(this.invaccHeader, {
                    periodFrom: '',
                    periodTo: '',
                });
            }
        },
        /* 获取ERP OUID */
        getErpOuIdByOrgCode (organizationCode) {
            return axios.get('/gscint/hw/invacc/getErpOuIdByOrgCode', {
                params: {
                    organizationCode
                }
            })
            .then((res) => {
                this.invaccHeader.orgId = res.data || '';
            });
        },
        showCustomDate (type) {
            this.dateModal.show = true;
            this.dateSearch(type);
        },
        fromValidate () {
            let flag = false;
            this.$refs.formHeader.validate((valid) => {
                flag = valid;
            });
            return flag;
        },
        /* 新建查询 */
        async search () {
            if (this.fromValidate()) {
                this.transactionModule.settings.currentPage = 1;
                this.queryItemList(this.headerId ? '/gscint/hw/invacc/queryLines' : '/gscint/hw/invacc/queryTransactions');
            }
        },
        async queryItemList (url) {
            let {
                    currentPage, pageSize
                } = this.transactionModule.settings;
                this.loading = true;
                await queryList(url, {
                    ...this.invaccHeader,
                    vendorCode: this.vendorCode,
                    pageNum: currentPage,
                    pageSize
                }, this)
                .then(({list, total}) => {
                    this.transactionModule.tableData = list;
                    this.transactionModule.settings.total = total;
                });
                this.loading = false;
        },
        async summaryList (url) {
            let {
                currentPage, pageSize
            } = this.summaryModule.settings;
            this.loading = true;
            await queryList(url, {
                ...this.invaccHeader,
                vendorCode: this.vendorCode,
                pageNum: currentPage,
                pageSize
            }, this)
            .then(({list, total}) => {
                this.summaryModule.tableData = list;
                this.summaryModule.settings.total = total;
            });
            this.loading = false;
        },
        /* 保存 */
        save () {
            this.$refs.formHeader.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    axios.post('/gscint/hw/invacc/save', {
                        vendorCode: this.vendorCode,
                        ...this.invaccHeader
                    })
                    .then((res) => {
                        this.loading = false;
                        let {success, msg, data} = res.data;
                        if (success && data && data.code !== -1) {
                            this.$Modal.success({
                                content: this.$t('fpzInvaccCommon.t39')
                            });
                            this.$closeTab({
                                name: 'fpzInvaccAdd'
                            });
                        } else {
                            this.$Modal.error({
                                content: msg || (data && data.message)
                            });
                        }
                    })
                    .catch(() => {
                        this.showErrorTips();
                    });
                }
            });
        },
        goBack () {
            this.$router.push({
                name: 'fpzInvaccSearch'
            });
        },
        // detailOnPageSizeChange (pageNum, pageSize) {
        //     if (this.fromValidate()) {
        //         this.detailModule.settings.currentPage = 1;
        //         this.detailModule.settings.pageSize = pageSize;
        //         queryLineTrcs(this, this.headerId, this.itemId, this.headerId ? 'detail' : 'new');
        //     };
        // },
        // detailOnPageChange (pageNum, pageSize) {
        //     if (this.fromValidate()) {
        //         this.detailModule.settings.currentPage = pageNum;
        //         queryLineTrcs(this, this.headerId, this.itemId, this.headerId ? 'detail' : 'new');
        //     }
        // },
        /* 期间查询 */
        dateSearch (periodFlag) {
            this.periodFlag = periodFlag;
            this.loading = true;
            let {orgId, organizationId, organizationCode} = this.invaccHeader;
            axios.post('/gscint/hw/invacc/getPeriodDate', {
                module: 'INV',
                orgId,
                organizationId,
                organizationCode,
                vendorCode: this.vendorCode,
                // vendorSiteCode: this.invaccHeader.vendorSiteCode,
                status: 'Closed',
                periodFlag
            })
            .then((res) => {
                this.loading = false;
                let {success, data, message} = res.data;
                if (success) {
                    this.dateModal.tableData = data.data || [];
                    let tableData = this.dateModal.tableData;
                    /* 非第一次对账，开始期间默认上一次结束期间的下一个期间，且不允许修改 */
                    if (periodFlag === 'start' && tableData.length === 1) {
                        this.invaccHeader.periodFrom = tableData[0].periodNameGsc;
                    }
                } else {
                    this.$Modal.error({
                        content: message
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        /* 日期选择 */
        dateOnRowClick (row) {
            let error = false;
            let isEnd = this.periodFlag === 'end'
            if (isEnd) {
                // row.periodNameGsc
                console.log(moment(row.periodNameGsc).format('x'));
                console.log(moment(this.invaccHeader.periodFrom).format('x'));
                if (moment(row.periodNameGsc).format('x') < moment(this.invaccHeader.periodFrom).format('x')) {
                    error = true;
                }
            }
            if (!error) {
                this.dateModal.show = false;
                this.invaccHeader[isEnd ? 'periodTo' : 'periodFrom'] = row.periodNameGsc;
            } else {
                this.$Modal.warning({
                    content: this.$t('fpzInvaccCommon.t38')
                });
            }
        },
        /* 查询头信息 */
        queryHeader (headerId) {
            this.loading = true;
            axios.post('/gscint/hw/invacc/queryHeader', {
                headerId,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                this.loading = false;
                let data = res.data.data;
                if (data) {
                    this.invaccHeader = {
                        ...data
                    }
                    let stepObj = {
                        'NEW': 1,
                        'REJECT': 3,
                        'VCONFIRM': 2,
                        'CLOSED': 3
                    }
                    this.step = stepObj[this.invaccHeader.status];
                    this.$nextTick(() => {
                        /* 明细 */
                        this.search();
                        /* 汇总 */
                        this.summaryList('/gscint/hw/invacc/queryLinesSummary');
                    });
                    //this.$emit('getHeaderInfo', this.invaccHeader);
                    // this.queryLinesSummary(headerId);
                    // queryLineTrcs(this, this.headerId, null, 'detail', 'transactionModule');
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // /* 新建通用查询 */
        // createQuery (url, moduleName) {
        //     this.loading = true;
        //     axios.post(url, {
        //         vendorCode: this.vendorCode,
        //         ...this.invaccHeader,
        //         organizationCode: this.invaccHeader.organizationCode,
        //         pageNum: this[moduleName].settings.currentPage,
        //         pageSize: this[moduleName].settings.pageSize
        //     })
        //     .then((res) => {
        //         this.loading = false;
        //         let {list, total} = res.data.data;
        //         if (list) {
        //             this[moduleName].tableData = list;
        //             this[moduleName].settings.total = total;
        //         }
        //     })
        //     .catch(() => {
        //         this.showErrorTips();
        //     });
        // },
        // /* 新建汇总 */
        // queryTransactionsSummary () {
        //     this.createQuery('/gscint/hw/invacc/queryTransactionsSummary', 'summaryModule');
        // },
        // /* 汇总 */
        // queryLinesSummary (headerId) {
        //     axios.post('/gscint/hw/invacc/queryLinesSummary', {
        //         headerId,
        //         vendorCode: this.vendorCode,
        //         pageNum: this.summaryModule.settings.currentPage,
        //         pageSize: this.summaryModule.settings.pageSize
        //     })
        //     .then((res) => {
        //         console.log('res', res);
        //         let {list, total} = res.data.data;
        //         this.summaryModule.tableData = list;
        //         this.summaryModule.settings.total = total;
        //     });
        // },
        summaryOnPageSizeChange (pageNum, pageSize) {
            this.summaryModule.settings.currentPage = 1;
            this.summaryModule.settings.pageSize = pageSize;
            this.summaryList('/gscint/hw/invacc/queryLinesSummary');
        },
        summaryOnPageChange (pageNum, pageSize) {
            this.summaryModule.settings.currentPage = pageNum;
            this.summaryList('/gscint/hw/invacc/queryLinesSummary');
        },
        transactionOnPageSizeChange (pageNum, pageSize) {
            this.transactionModule.settings.currentPage = 1;
            this.transactionModule.settings.pageSize = pageSize;
            this.queryItemList(this.headerId ? '/gscint/hw/invacc/queryLines' : '/gscint/hw/invacc/queryTransactions');
            
        },
        transactionOnPageChange (pageNum, pageSize) {
            this.transactionModule.settings.currentPage = pageNum;
            this.queryItemList(this.headerId ? '/gscint/hw/invacc/queryLines' : '/gscint/hw/invacc/queryTransactions');
        },
        cleanData () {
            this.$refs['formHeader'].resetFields();
            this.transactionModule.tableData = [];
            this.transactionModule.settings.currentPage = 1;
            this.transactionModule.settings.total = 0;
        },
        init () {
            if (!this.hideTable) {
                this.getSRMInvLovListNew((data) => {
                    this.orgList = data.map((item) => {
                        return {
                            ...item,
                            label: item.organizationName,
                            value: item.organizationCode,
                        };
                    });
                    if (!this.readonly) {
                        this.invaccHeader.status = 'NEW';
                        this.invaccDetailTabs = 'invaccItemDetail';
                    } else {
                        this.headerId = this.$route.query.id;
                        this.queryHeader(this.headerId);
                        this.invaccDetailTabs = 'TrcItemDetail';
                    }
                });
                this.getDict('INT_RECONCILIATION_STATUS', (data) => {
                    this.statusList = data.filter((item) => item.email !== 'N');
                });
            }
        }
    },
    mounted() {
        this.init();
    },
    activated() {
        this.init();
    },
}

</script>
<style lang="less" scoped>
.mr8 {
    margin-right: 8px;
}
</style>